import { render } from "./AILibrarySearch.vue?vue&type=template&id=2bd5b1d9&scoped=true"
import script from "./AILibrarySearch.vue?vue&type=script&lang=js"
export * from "./AILibrarySearch.vue?vue&type=script&lang=js"

import "./AILibrarySearch.vue?vue&type=style&index=0&id=2bd5b1d9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd5b1d9"]])

export default __exports__